<template>
  <transition name="fade">
    <div v-if="active" class="backdrop">
      <div class="loader-container">
        <div class="dots-loader">
          <span v-for="n in 5" :key="n"></span>
        </div>
        <p class="loader-text">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { onMounted, onUnmounted, watch } from 'vue'

const props = defineProps({
  active: Boolean,
  message: { type: String, default: 'Cargando...' },
  lockScroll: { type: Boolean, default: true }
})

const lockScroll = () => {
  if (props.lockScroll && typeof document !== 'undefined') document.body.style.overflow = 'hidden'
}
const unlockScroll = () => {
  if (props.lockScroll && typeof document !== 'undefined') document.body.style.overflow = ''
}

watch(() => props.active, (val) => (val ? lockScroll() : unlockScroll()))
onMounted(() => props.active && lockScroll())
onUnmounted(unlockScroll)
</script>

<style scoped>
/* Fondo */
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-container {
  text-align: center;
  animation: appear 0.4s ease-out;
}

/* --- Dots loader tipo ola azul fluida --- */
.dots-loader {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 5px;
  height: 40px;
}

/* Círculos animados */
.dots-loader span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1d40af;
  animation: wave 0.5s linear infinite, blueShift 2.5s linear infinite;
}

/* Retraso progresivo para el efecto ola */
.dots-loader span:nth-child(1) { animation-delay: 0s, 0s; }
.dots-loader span:nth-child(2) { animation-delay: 0.1s, 0.2s; }
.dots-loader span:nth-child(3) { animation-delay: 0.2s, 0.4s; }
.dots-loader span:nth-child(4) { animation-delay: 0.3s, 0.6s; }
.dots-loader span:nth-child(5) { animation-delay: 0.4s, 0.8s; }

/* Movimiento de ola fluido */
@keyframes wave {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.9;
  }
  25% {
    transform: translateY(-10px);
    opacity: 1;
  }
  50% {
    transform: translateY(0);
    opacity: 0.95;
  }
  75% {
    transform: translateY(3px);
  }
}

/* Variación de tonos azules con matices suaves */
@keyframes blueShift {
  0% { background-color: #1D40AF; }   /* Azul corporativo */
  25% { background-color: #365DF0; }  /* Azul brillante */
  50% { background-color: #4F8CF0; }  /* Azul claro */
  75% { background-color: #274EB5; }  /* Azul profundo */
  100% { background-color: #1D40AF; } /* Vuelta al original */
}

/* Texto animado */
.loader-text {
  margin-top: 1rem;
  font-size: 1rem;
  color: #334155;
  letter-spacing: 0.03em;
  animation: textPulse 1s linear infinite;
}

@keyframes textPulse {
  0%, 100% { opacity: 0.8; transform: translateY(0); }
  50% { opacity: 1; transform: translateY(-2px); }
}

/* Aparición inicial */
@keyframes appear {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

/* Transición del fade */
.fade-enter-active,
.fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from,
.fade-leave-to { opacity: 0; }
</style>
